import React, {useMemo} from "react";
import {Box, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import Button from "../../../components/base/button/button";
import {routeFunctions} from "../../../../core/models/static/routes/app-routes";

const PartFormQualificationErrorIndicator = ({
                                                 onRetry,
                                                 errorMessage,
                                                 customerId,
                                                 showCustomerProfileButton = false,
                                             }) => {
    const {t} = useTranslation("components", {keyPrefix: "app-specific.part-form-qualification-error"});

    const customerProfilePath = useMemo(() => {
        if (!customerId) {
            return null;
        }
        return routeFunctions.customer.generalInformation.profile(customerId);
    }, [customerId]);

    const displayMessage = errorMessage?.trim() || t("message");
    const showProfileLink = showCustomerProfileButton && !!customerProfilePath;

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                py: 3,
                px: 2,
                gap: 2,
                width: "100%",
            }}
        >
            <Typography
                variant="body2"
                color="text.secondary"
                textAlign="center"
                sx={{whiteSpace: "pre-wrap"}}
            >
                {displayMessage}
            </Typography>
            <Box sx={{display: "flex", flexWrap: "wrap", gap: 1, justifyContent: "center"}}>
                {showProfileLink && (
                    <Button
                        variant="contained"
                        color="primary"
                        component={Link}
                        to={customerProfilePath}
                        target={'_blank'}
                    >
                        {t("goToCustomerProfile")}
                    </Button>
                )}
                <Button variant={showProfileLink ? "outlined" : "contained"} color="primary" onClick={onRetry}>
                    {t("tryAgain")}
                </Button>
            </Box>
        </Box>
    );
};

export default PartFormQualificationErrorIndicator;
